import { register } from "@rill/loader";

register(
  {
    name: "complexes",
    meta: ["no-bust", "complex"],
    ttl: "2 hours",
  },
  async ({ api }) => {
    const query = {
      limit: false,
    };

    const res = await api("complex", { query });
    const data = await res.json();
    return data;
  }
);
